<template>
    <section class="search text-light bg-primary">
      <div class="container py-4 mb-3">
        <h2 class="fs-4"><i class="fa-solid fa-magnifying-glass"></i> Pesquisar</h2>
        <form @submit.prevent="handleSearch">
          <div class="row mb-2 gy-2">
            <!-- Campo de texto para Marca/Modelo -->
            <div class="col-6 col-md-4">
              <label class="visually-hidden" for="name">Name</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="name"
                v-model="searchParams.name"
                placeholder="Marca, Modelo"
                autofocus
              />
            </div>
            <!-- Dropdown de Categorias -->
            <div class="col-6 col-md-3">
              <label class="visually-hidden" for="category">Categoria</label>
              <select
                class="form-control form-control-sm"
                id="category"
                v-model="searchParams.category"
              >
                <option value="">{{ $t("component.search.select") }}</option>
                <option v-for="category in categories" :key="category.id" :value="category.id">
                    {{ $t(`component.search.categories.${category.id}`) }}
                </option>
              </select>
            </div>
            <!-- Dropdown de Estados -->
            <div class="col-6 col-md-2">
              <label class="visually-hidden" for="state">Estado</label>
              <select
                class="form-control form-control-sm"
                id="state"
                v-model="searchParams.state"
              >
                <option value="">{{ $t("component.search.select") }}</option>
                <option v-for="state in states" :key="state.id" :value="state.id">
                    {{ state.name }}
                </option>
              </select>
            </div>
            <!-- Ano -->
            <div class="col-6 col-md-3">
              <label class="form-label" for="state">Ano</label>
              <div class="input-group input-group-sm">
                <select
                  class="form-control form-control-sm"
                  id="yearStart"
                  v-model="searchParams.yearStart"
                  @change="updateEndYears"
                >
                    <option value="">{{ $t("component.search.select") }}</option>
                    <option v-for="year in years" :key="'start-' + year" :value="year">
                        {{ year }}
                    </option>
                </select>
                <select
                  class="form-control form-control-sm"
                  id="yearEnd"
                  v-model="searchParams.yearEnd"
                >
                    <option value="">{{ $t("component.search.select") }}</option>
                    <option v-for="year in filteredEndYears" :key="'end-' + year" :value="year">
                        {{ year }}
                    </option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <!-- Radio Buttons -->
            <div class="d-grid">
              <div v-for="type in types" :key="type.id" class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  :id="type.id"
                  :value="type.id"
                  v-model="searchParams.type"
                />
                <label class="form-check-label" :for="type.id">{{ $t(`component.search.types.${type.id}`) }}</label>
              </div>
            </div>
            <div class="d-grid gap-2 justify-content-md-end">
              <button type="submit" class="btn btn-secondary btn-sm">
                <i class="fa-solid fa-hand-pointer"></i> Buscar
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
  </template>
  
  <script>
  import system from "@/services/system.json";
  
  export default {
    data() {
      return {
        categories: [],
        states: [],
        years: [],
        types: [],
        searchParams: {
          name: "",
          category: "",
          state: "",
          yearStart: "",
          yearEnd: "",
          type: "all",
        },
      };
    },
    computed: {
      filteredEndYears() {
        if (!this.searchParams.yearStart) {
          return this.years;
        }
        return this.years.filter((year) => year >= this.searchParams.yearStart);
      },
    },
    methods: {
      handleSearch() {
        if (this.searchParams.state) {
            this.$router.push(`/${this.searchParams.state}`);
            } else {
            this.$router.push("/anuncios");
            }
      },
      loadYears() {
        const currentYear = new Date().getFullYear();
        this.years = Array.from({ length: currentYear - 1989 }, (_, i) => 1990 + i);
      },
      loadSystemData() {
        this.categories = system.search.categories.map((cat) => ({
          id: cat.id,
          label: cat.id.charAt(0).toUpperCase() + cat.id.slice(1),
        }));
        this.states = system.search.states.map((state) => ({
          id: state.id,
          name: state.id,
        }));
        this.types = system.search.types.map((type) => ({
          id: type.id,
          name: type.id,
        }));
      },
      updateEndYears() {
        // Reseta o ano final se for menor que o inicial
        if (
          this.searchParams.yearEnd &&
          this.searchParams.yearEnd < this.searchParams.yearStart
        ) {
          this.searchParams.yearEnd = "";
        }
      },
    },
    mounted() {
      this.loadYears();
      this.loadSystemData();
    },
  };
  </script>
  
  <style scoped>
  </style>
  